export default __webpack_public_path__ + "static/media/new_profile.0c37eba8.mp3";